<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="permissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-money-bill-transfer"></i></span>{{ 'TariffRate.Header' | translate }}</h1>
  <p-card>
    <p-accordion>
      <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
        <form [formGroup]="searchForm">
          <div class="p-fluid formgrid grid">
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'TariffRate.Form.SKU' | translate }}</label>
              <input type="text" pInputText formControlName="sku" [(ngModel)]="searchParams.sku"/>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'TariffRate.Form.Forwarder' | translate }}</label>
              <p-multiSelect formControlName="forwarder" [options]="forwarderOptions" [filter]="true" [(ngModel)]="searchParams.forwarder"
                 placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-multiSelect>
            </div>
            <div class="col-12 md:col-6 lg:col-4 mb-3">
              <label>{{ 'TariffRate.Form.Effective' | translate }}</label>
              <p-dropdown formControlName="isActivated" [options]="isActivatedOptions" [(ngModel)]="searchParams.isActivated"
                [showClear]="true" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
              </p-dropdown>
            </div>
          </div>
          <div class="grid">
            <div class="col">
              <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchClickBtn($event)"></button>
              <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetClickBtn($event)" class="p-button-secondary ml-2"></button>
              <button pButton pRipple label="{{ 'TariffRate.Button.New' | translate }}" (click)="addClickBtn($event)" class="ml-2"></button>
              <button pButton pRipple label="{{ 'TariffRate.Button.Import' | translate }}" (click)="importClickBtn($event)" class="ml-4"></button>
              <button pButton pRipple label="{{ 'TariffRate.Button.Export' | translate }}" [disabled]="tariffRateRows.length === 0" (click)="exportClickBtn($event)" class="ml-2"></button>
            </div>
          </div>
        </form>
      </p-accordionTab>
    </p-accordion>
    <div class="mt-2">
      <laas-data-table [tableKey]="preferenceKey" [selectable]="false" [dataKey]="'sku'" [value]="tariffRateRows" [defaultColumns]="columns" [loading]="isLoading">
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'forwarder'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:forwarderOptions | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'declarationDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'isActivated'">
                <div class="overflow-text">
                  {{ rowData[col.field] | optionsMapping:isActivatedOptions | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'startDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'endDt'">
                <div class="overflow-text">
                  {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-'}}
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'__action'">
                <span class="icon" (click)="actionBtnClick($event, rowData)"><i class="fas fa-book"></i></span>
              </ng-container>
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
     </div>
  </p-card>
  <ng-container *ngIf="isShowImportTariffRateModal">
    <laas-tariff-rate-setting-import [(visible)]="isShowImportTariffRateModal" (importClick)="importTariffRate($event)"></laas-tariff-rate-setting-import>
  </ng-container>
</div>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
